import React from "react";
import { Box, Flex } from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import { formatZoneListReviewSceneValue } from "../../model/store-commissioning/formatSceneLevelValues";
import * as zoneTypeKeys from "../../model/lighting-zone-types/zoneTypeKeys.js";
import BehindFeatureFlag from "../BehindFeatureFlag/index.js";
import * as features from "../../utils/features";

const StoreZoneReviewItem = props => {
  const isCbusZone = props.zoneType === zoneTypeKeys.CBUS;
  return (
    <Box className="fable:border fable:p-8">
      <h3 className="cb-u-word-wrap">{props.zoneName}</h3>
      <span className="fable:px-4 fable:py-2 fable:bg-gray-100">Scenes</span>
      {props.scenes.map((scene, index) => {
        return (
          <Flex key={index} gap="md" alignItems="center" className="fable:mt-2">
            <div style={{ flex: 1 }}>
              <span>{scene.description}</span>
            </div>
            <div style={{ flexShrink: 0 }}>
              <span className="fable:text-4xl">
                {formatZoneListReviewSceneValue(
                  props.zoneType,
                  scene.levelPercentage
                )}
              </span>
            </div>
          </Flex>
        );
      })}
      <div className="fable:border-b fable:mt-2" />
      {isCbusZone && (
        <React.Fragment>
          <Flex gap="md" alignItems="center" className="fable:mt-2">
            <div style={{ flex: 1 }}>
              <span className="fable:px-4 fable:py-2 fable:bg-gray-100">Lux Sensor</span>
            </div>
            <div style={{ flexShrink: 0 }}>
              <span>{props.hasLuxMeter === true ? "Yes" : "No"}</span>
            </div>
          </Flex>
          {props.luxSensorId && (
            <Flex gap="md" alignItems="center" className="fable:mt-2">
              <div style={{ flex: 1 }}>
                <span className="fable:px-4 fable:py-2 fable:bg-gray-100">Lux Sensor ID</span>
              </div>
              <div style={{ flexShrink: 0 }}>
                <span>{props.luxMeterCbusGroupId}</span>
              </div>
            </Flex>
          )}
          <BehindFeatureFlag feature={features.PIR_ID}>
            {props.pirSensorIds && (
              <Flex gap="md" alignItems="center" className="fable:mt-2">
                <div style={{ flex: 1 }}>
                  <span className="fable:px-4 fable:py-2 fable:bg-gray-100">PIR IDs</span>
                </div>
                <div style={{ flexShrink: 0 }}>
                  <span>{props.pirSensorIds.join(", ")}</span>
                </div>
              </Flex>
            )}
          </BehindFeatureFlag>
          <Flex gap="md" alignItems="center" className="fable:mt-2">
            <div style={{ flex: 1 }}>
              <span className="fable:px-4 fable:py-2 fable:bg-gray-100">CBUS Group</span>
            </div>
            <div style={{ flexShrink: 0 }}>
              <span>{props.lightsCbusGroupId}</span>
            </div>
          </Flex>
        </React.Fragment>
      )}
      {!isCbusZone && (
        <Flex gap="md" alignItems="center" className="fable:mt-2">
          <div style={{ flex: 1 }}>
            <span className="fable:px-4 fable:py-2 fable:bg-gray-100">Pin Group</span>
          </div>
          <div style={{ flexShrink: 0 }}>
            <span>{props.pinId}</span>
          </div>
        </Flex>
      )}
    </Box>
  );
};
StoreZoneReviewItem.propTypes = {
  storeId: PropTypes.string,
  zoneId: PropTypes.string,
  zoneName: PropTypes.string,
  scenes: PropTypes.arrayOf(
    PropTypes.shape({
      levelPercentage: PropTypes.shape({
        isOn: PropTypes.bool,
        levelPercentage: PropTypes.number,
        rampTimeSeconds: PropTypes.number
      }),
      name: PropTypes.string
    })
  ),
  lightsCbusGroupId: PropTypes.number,
  luxMeterCbusGroupId: PropTypes.number,
  hasLuxMeter: PropTypes.bool,
  setConfirmationDialog: PropTypes.func,
  pirId: PropTypes.number
};

export default StoreZoneReviewItem;
